// UI-16: text logic for the kiosk on-screen keyboard, kept free of the DOM so
// it can be unit-tested with `node --test` (test/javascript).
//
// state: { value, start, end, shift, capitalize: "words"|"sentences"|"none", maxLength }

const LETTER = /\p{L}/u

export function applyKey(state, key) {
  switch (key) {
    case "shift":
      return { ...state, shift: !state.shift }
    case "clear":
      return settle(state, { value: "", start: 0, end: 0 })
    case "backspace":
      return settle(state, backspace(state))
    case "space":
      return settle(state, insert(state, " "))
    default:
      return settle(state, insert(state, state.shift && LETTER.test(key) ? key.toUpperCase() : key))
  }
}

// Whether the next letter should be uppercase, given the text before the caret.
export function autoShift(value, caret, capitalize) {
  const before = value.slice(0, caret)

  switch (capitalize) {
    case "words":
      return before === "" || /[\s\-']$/u.test(before)
    case "sentences":
      return before.trim() === "" || /[.!?]\s+$/u.test(before)
    default:
      return false
  }
}

function insert({ value, start, end, maxLength }, text) {
  const next = value.slice(0, start) + text + value.slice(end)
  if (maxLength && next.length > maxLength) return null

  const caret = start + text.length
  return { value: next, start: caret, end: caret }
}

function backspace({ value, start, end }) {
  if (start !== end) return { value: value.slice(0, start) + value.slice(end), start, end: start }
  if (start === 0) return { value, start, end }

  return { value: value.slice(0, start - 1) + value.slice(end), start: start - 1, end: start - 1 }
}

// Apply an edit (null means "rejected") and recompute auto-capitalization.
function settle(state, edit) {
  if (edit === null) return state

  return { ...state, ...edit, shift: autoShift(edit.value, edit.start, state.capitalize) }
}
